export enum FixedPhraseKinds {
  User,
  Department,
  CommonDepartment,
  Format,
  TemporarySaveUser,
  ReceptionUser,
  ReceptionDepartment,
  AiUser,
  AiDepartment,
  AiCommonDepartment,
  AiFormat,
}

export class FixedPhraseKindsUtility {
  private static readonly _aiFixedPhraseKinds: FixedPhraseKinds[] = [
    FixedPhraseKinds.AiUser,
    FixedPhraseKinds.AiDepartment,
    FixedPhraseKinds.AiCommonDepartment,
    FixedPhraseKinds.AiFormat
  ];

  static isAiPhrase(source: FixedPhraseKinds): boolean {
    return this._aiFixedPhraseKinds.indexOf(source) >= 0;
  }
}
